import * as z from "zod/v4";
import { ProductCatalogItemSchema } from "./get-product-catalog";

export const getConsignmentCatalog = {
  name: "getConsignmentCatalog" as const,
  input: z.object({
    pageSize: z.number().min(1).max(100).optional().default(20),
    page: z.number().min(0).optional().default(0),
    search: z.string().optional(),
  }),
  output: z.object({
    catalogItems: z.array(ProductCatalogItemSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
};
